import React from 'react';
import PrivacyPolicyView from './PrivacyPolicyView';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

function PrivacyPolicy(props) {
    return <PrivacyPolicyView {...props}/>;
}

const mapStateToProps = (state) => ({
    isMobileView: state.appState.deviceInfo.isMobileView,
    isXSView: state.appState.deviceInfo.isXSView,
});

export default connect(mapStateToProps, {})(withRouter(PrivacyPolicy));
